(function ($) {
  (() => {
    var $body = $('body'), $doc = $(document), $win = $(window);
    initMultiTab()
    if (window.innerWidth < 1025) {
      menuSidebarMobile();
    }
    let checkMenuMobile;
    window.innerWidth > 1024 ? checkMenuMobile = true : checkMenuMobile = false;
    $win.on('resize', () => {
      if (window.innerWidth > 1024) {
          document.body.classList.remove('menu_open')
      } else if (checkMenuMobile) {
          checkMenuMobile = false;
          menuSidebarMobile()
          initMultiTab()
          initMultiTabMobile()
      }
    });

    function initMultiTab() {
      let designMode, showMenu, check = true;
      document.body.matches('.shopify-design-mode') ? designMode = true : designMode = false;
      document.body.matches('.menu_open') ? showMenu = true : showMenu = false;

      const loadMenuDefault = () => {
        if (check) {
          check = false;
          initMobileMenuDefault(url)
        }
      }

      const loadMenuTab = () => {
        if (check) {
          check = false;
          initMultiTabMobile()
        }
      }

      if ($('[data-menu-tab]').length > 0) {

        var active = $('[data-menu-tab] li.is-active').data('load-page'),
          url = window.routes.root + `/search?type=product&q=${active}&view=ajax_mega_menu`;

        if ($body.hasClass('template-index')) {
          if ($win.width() < 1025) {
            if (window.mobile_menu == 'default') {
              window.addEventListener('load', () => {
                if (designMode || showMenu) {
                  loadMenuDefault();
                }
                else {
                  document.body.addEventListener('click', () => {
                    loadMenuDefault();
                  }, false)
                }
              }, false)
            } else {
              window.addEventListener('load', () => {
                if (designMode || showMenu) {
                  loadMenuTab();
                }
                else {
                  document.body.addEventListener('click', () => {
                    loadMenuTab();
                  }, false)
                }
              }, false)
            }
          }
        } else {
          if ($win.width() < 1025) {
            if (window.mobile_menu == 'default') {
              window.addEventListener('load', () => {
                if (designMode || showMenu) {
                  loadMenuDefault();
                }
                else {
                  document.body.addEventListener('click', () => {
                    loadMenuDefault();
                  }, false)
                }
              }, false)
            } else {
              window.addEventListener('load', () => {
                if (designMode || showMenu) {
                  loadMenuTab();
                }
                else {
                  document.body.addEventListener('click', () => {
                    loadMenuTab();
                  }, false)
                }
              }, false)
            }
          }
        }
      } else {
        var url = window.routes.root + '/search?view=ajax_mega_menu';

        if ($win.width() < 1025) {
          if (window.mobile_menu == "default") {
            if (designMode || showMenu) {
              loadMenuDefault();
            }
            else {
              document.body.addEventListener("click", () => {
                loadMenuDefault();
              }, false)
            }
          } else {
            window.addEventListener("load", () => {
              if (designMode || showMenu) {
                loadMenuTab();
              }
              else {
                document.body.addEventListener("click", () => {
                  loadMenuTab();
                }, false)
              }
            }, false)
          }
        }
      }
    }

    function initMobileMenuDefault(url) {
      const menuMobile = $('[data-navigation-mobile]');

      const sourceNav = $('#NavgationMenuMobile[data-navigation-menu-mobile]').first();
      const style = sourceNav.attr('style') != undefined ? sourceNav.attr('style') : '';

      menuMobile.each(function () {
        if (this.querySelector('nav[data-mobile-menu-nav]')) return;

        const nav = document.createElement('nav');
        nav.className = 'header__inline-menu';
        nav.setAttribute('data-navigation', '');
        nav.setAttribute('data-mobile-menu-nav', '');
        nav.setAttribute('data-mobile-panel-source', 'NavgationMenuMobile');
        nav.setAttribute('role', 'navigation');
        if (style) nav.setAttribute('style', style);

        // Only clone the top-level links. Panel templates stay in the single
        // source root and are mounted into the sidebar host on demand.
        sourceNav.children('.menu_list').each(function () {
          nav.appendChild(this.cloneNode(true));
        });

        const panelHost = document.createElement('div');
        panelHost.setAttribute('data-mobile-panel-host', '');
        nav.appendChild(panelHost);
        this.appendChild(nav);
      });

      const topLanCur = $('.top-language-currency');
      const lanCurMobile = $('#navigation-mobile .nav-currency-language');

      if (lanCurMobile.text().trim() == '' && topLanCur.length > 0) lanCurMobile.append(`<div class="top-language-currency">${topLanCur.html()}</div>`)

      // Menu Mobile Tab on Header Vertical
      const menuVertical = document.querySelector('.header-nav-vertical-menu .vertical-menu .header__menu-vertical')

      if (menuVertical) {
        document.querySelector('.halo-sidebar.halo-sidebar_menu').classList.add('has-menu-vertical')

        const menuVerticalTitle = document.querySelector('.header-nav-vertical-menu .vertical-menu .categories-title__button .title').innerHTML
        const navMobile = document.querySelector('.site-nav-mobile.nav')
        const navMobileTitle = navMobile.querySelector('.menu-heading-mobile')
        const span = document.createElement('span')
        span.classList.add('title')
        span.innerHTML = menuVerticalTitle;

        navMobileTitle.appendChild(span);
        navMobile.appendChild(menuVertical);

        const menuVerticalNav = document.querySelector('.site-nav-mobile.nav .header__menu-vertical')
        menuVerticalNav.classList.add('header__inline-menu')

        const tabTitle = document.querySelectorAll('.site-nav-mobile.nav .menu-heading-mobile .title')
        const mobileMenu = document.querySelectorAll('.site-nav-mobile.nav .header__inline-menu')
        tabTitle[0].classList.add('is-active')
        mobileMenu[0].classList.add('is-active')

        tabTitle.forEach((item, index) => {
          item.addEventListener('click', () => {
            tabTitle.forEach(e => e.classList.remove('is-active'))
            item.classList.add('is-active')
            mobileMenu.forEach(e => e.classList.remove('is-active'))
            mobileMenu[index].classList.add('is-active')
          })
        })
      }
    }

    function initMultiTabMobile() {
      if ($win.width() < 1025) {
        if (window.mobile_menu == 'custom') {
          var chk = true,
            menuElement = $('[data-section-type="menu"]'),
            menuMobile = $('[data-navigation-mobile]'),
            menuTabMobile = $('[data-navigation-tab-mobile]');

          const loadMenu = () => {
            if (chk) {
              chk = false;
              const content = document.createElement('div');
              const tab = document.createElement('ul');

              Object.assign(tab, {
                className: 'menu-tab list-unstyled'
              });

              tab.setAttribute('role', 'menu');

              menuElement.each((index, element) => {
                var currentMenu = element.querySelector('template').content.firstElementChild.cloneNode(true);

                if (index == 0) {
                  currentMenu.classList.add('is-visible');
                } else {
                  currentMenu.classList.add('is-hidden');
                }

                content.appendChild(currentMenu);
              });

              content.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((element, index) => {
                var tabTitle = element.dataset.heading,
                  tabId = element.getAttribute('id'),
                  tabElement = document.createElement('li');

                Object.assign(tabElement, {
                  className: 'item'
                });

                tabElement.setAttribute('role', 'menuitem');

                if (index == 0) {
                  tabElement.classList.add('is-active');
                }

                tabElement.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`;


                tab.appendChild(tabElement);
              });

              $('.list-menu-loading').remove();
              menuTabMobile.html(tab);
              menuMobile.html(content.innerHTML);
            }

          }

          if ($('.header-nav-plain .header-language_currency').length > 0) {
            const topLanCur = $('.top-language-currency');
            const lanCurMobile = $('#navigation-mobile .nav-currency-language');
            if (lanCurMobile.text().trim() == '' && topLanCur.length > 0) lanCurMobile.append(`<div class="top-language-currency">${topLanCur.html()}</div>`)
          }

          if (document.body.matches('.menu_open')) {
            loadMenu();
          }

          document.body.addEventListener('click', () => {
            loadMenu();
          }, false);
        }
      }
    }

    function menuSidebarMobile() {
      var buttonIconOpen = $('.mobileMenu-toggle'),
        buttonClose = $('.halo-sidebar-close, .background-overlay');

      const menuSidebarMobileOpen = () => {

        $body.addClass('menu_open');
        $('.list-menu-loading').remove();
        if (window.mobile_menu == 'default') {
          if (!$('#navigation-mobile nav[data-mobile-menu-nav]').length) {
            initMobileMenuDefault();
          }
          if (!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length) {
            $('.header .header__inline-menu').appendTo('#navigation-mobile .site-nav-mobile.nav');
          }
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length) {
          $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length) {
          $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length) {
          $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .top-language-currency').length) {
          if ($('.header').hasClass('header-03')) {
            $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
          } else if ($('.header').hasClass('header-05')) {
            $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
          } else {
            $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
          }
        }
      }

      if (document.body.matches('.menu_open')) {
        menuSidebarMobileOpen();
      }

      buttonIconOpen.off('click.toggleCurrencyLanguage').on('click.toggleCurrencyLanguage', (event) => {
        event.preventDefault();
        menuSidebarMobileOpen();
      });

      buttonClose.off('click.toggleCloseCurrencyLanguage').on('click.toggleCloseCurrencyLanguage', () => {
        $body.removeClass('menu_open menu_open_mb');
        $('#navigation-mobile [data-mobile-panel-host]').empty();
        $('#navigation-mobile').off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
          if (!$body.hasClass('menu_open')) {

            if (!$('.header .header__inline-menu').length) {
              if ($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')) {
                $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').not('[data-mobile-menu-nav]').appendTo('.header .header-bottom--wrapper .header-bottom-left');
              } else {
                $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').not('[data-mobile-menu-nav]').appendTo('.header .header-bottom--wrapper');
              }
            }
            if (!$('.header-top--wrapper .header-top--right .free-shipping-text').length) {
              if (!$('.header-04').hasClass('style_2')) {
                $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
              }
            }
            if (!$('.header-top--wrapper .header-top--right .header__location').length) {
              $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
            }
            if (!$('.header-top--wrapper .header-top--right .customer-service-text').length) {
              if ($('.header').hasClass('header-03')) {
                $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
              } else {
                $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
              }
            }
            if (!$('.header-language_currency .top-language-currency').length) {
              if ($('.header').hasClass('header-03')) {
                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
              } else if ($('.header').hasClass('header-04')) {
                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
              } else if ($('.header').hasClass('header-05')) {
                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
              } else {
                $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
              }
            }
          }
        })

      });

      $doc.on('click', '.halo-sidebar-close', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $body.removeClass('menu_open');
      });

      function openMobilePanel($panel, activeClass) {
        $body.addClass('menu_open_mb');

        // A panel is mounted from <template> immediately before this call.
        // Force the browser to commit its initial `left: 100vw` state before
        // switching to `left: 0`; otherwise both styles are resolved in the
        // same render pass and the slide-in transition is skipped.
        var panelElement = $panel[0];
        if (panelElement && !$panel.hasClass(activeClass)) {
          void panelElement.offsetWidth;
          $panel.addClass(activeClass);
        }

        $('.halo-sidebar_menu .halo-sidebar-wrapper').animate({ scrollTop: 0 }, 200);
      }

      function openMobilePanelFromTrigger(trigger, event) {
        var $trigger = $(trigger);
        var panelKey = $trigger.data('mobile-panel-trigger');
        var $navigation = $trigger.closest('[data-mobile-menu-nav], [data-navigation-menu-mobile]');

        if (!panelKey || !$navigation.length) return;

        // These entries also have a real href for SEO/fallback navigation.
        // On mobile the panel is the primary action, so cancel navigation
        // before any DOM lookup can throw or return an empty template.
        event.preventDefault();
        event.stopPropagation();

        var $panel = $navigation.find('.header-mobile-panel').filter(function () {
          return $(this).data('mobile-panel') === panelKey;
        }).first();

        if (!$panel.length) {
          var $template = $navigation.find('template[data-mobile-panel-template="' + panelKey + '"]').first();
          if (!$template.length) {
            var panelSourceId = $navigation.attr('data-mobile-panel-source');
            var panelSource = panelSourceId ? document.getElementById(panelSourceId) : null;
            $template = panelSource
              ? $(panelSource).find('template[data-mobile-panel-template="' + panelKey + '"]').first()
              : $();
          }
          var $panelHost = $navigation.find('[data-mobile-panel-host]').first();

          if ($template.length && $panelHost.length && $template[0].content.firstElementChild) {
            $panelHost.empty();
            $panel = $( $template[0].content.firstElementChild.cloneNode(true) );
            $panelHost[0].appendChild($panel[0]);
          }
        }

        var activeClass = $panel.data('mobile-panel-active-class');

        if (!$panel.length || !activeClass) return;

        openMobilePanel($panel, activeClass);
        $doc.trigger('blacklyte:mobile-panel-open', {
          panelKey: panelKey,
          panel: $panel[0]
        });
      }

      // Keep one shared entry point for the theme's legacy menu initializer.
      // The panel markup now lives in templates, so a second delegated handler
      // must use the same mount-and-open path instead of looking for a panel
      // that is not mounted yet.
      window.__blacklyteOpenMobilePanelFromTrigger = openMobilePanelFromTrigger;

      // Handle panel triggers in capture phase. Some theme/header handlers
      // stop bubbling or move the nav during menu transitions, which used to
      // leave the link canceled without mounting its panel.
      const previousPanelCaptureHandler = document.__blacklyteMobilePanelCaptureHandler;
      if (previousPanelCaptureHandler) {
        document.removeEventListener('click', previousPanelCaptureHandler, true);
      }

      const panelCaptureHandler = function (event) {
        if (window.innerWidth < 1025 && event.target && event.target.closest) {
          const trigger = event.target.closest('[data-mobile-panel-trigger]');
          if (trigger) openMobilePanelFromTrigger(trigger, event);
        }
      };

      document.__blacklyteMobilePanelCaptureHandler = panelCaptureHandler;
      document.addEventListener('click', panelCaptureHandler, true);
      $doc.off('click.blacklyteMobilePanelTrigger');
    }
  })()
})(jQuery);
